import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import { Form, Container } from 'react-bootstrap'

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}


const mapDispatchToProps = dispatch => ({

});

class selfAssessmentThank extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render() {
    return <Fragment>
      <div className="color-body">
        <NavbarComp bgblue={true} access_token={true} />
        <div className="page-sections">
          <div className='onboarding-confirm-wrap'>
            <Container>
              <div className='onboarding-confirm-contents'>
                <h2 className='main-title-style'>THANK YOU</h2>
                {this.props.auth.user !== null && this.props.auth.user.voluntary_test ? <>
                  <p>You have completed the voluntary assessment.</p>
                  <p>You can download your personalised sleep health report on the dashboard.</p>
                </> : null}
                <p>Establish your baseline and remember to come back at the start of your next shift to do your alertness test.</p>
                <div className='notnow-yes-btns'>
                  {this.props.auth.baseline ? <a href="/dashboard" rel="nofollow"><button className='notnow-btn'>DASHBOARD</button></a> : null}
                  {this.props.auth.baseline ? <a href="/daily-questionnaire" rel="nofollow"><button className='yes-btn'>ALERTNESS TEST</button></a> :
                    <a href="/alertness" rel="nofollow"><button className='yes-btn'>ALERTNESS TEST</button></a>}
                </div>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </Fragment>
  }
}

selfAssessmentThank.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(selfAssessmentThank);
